
export class LocationDetail {
    childLocations: any[];
    materialPools: any[];
    samples: any[];
    
    // filter child locations
    filter: any;
}
